import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://vyrdnupvwyvdmbveedfu.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ5cmRudXB2d3l2ZG1idmVlZGZ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA2Mjk3NTksImV4cCI6MjA4NjIwNTc1OX0.ct2yRGrjPCVnVwFGvGR_zoRTy8pLxXs2PK4CwydSUJ8";

export const supabase = createClient(supabaseUrl, supabaseKey);

